import React, { Component } from 'react';
import { Route } from 'react-router-dom';
import { Breadcrumb, Tabs } from '../../../components';
import { getDmService } from '../../../services/Api';
import Drafts from './Drafts';
import NewCampaign from './NewCampaign';

class Campaigns extends Component {
  state = {
    drafts: [],
  };

  componentDidMount() {
    this.loadDrafts();
    this.setHistoryLocation();
  }

  loadDrafts = () => {
    const { match, history } = this.props;

    getDmService('/Pedido/GetCampanhaMensagem').then(data => {
      this.setState({ drafts: data });
      if (data.length) {
        history.push(`${match.url}/rascunhos`);
      }
    });
  }

  setHistoryLocation = () => {
    const { history } = this.props;
    localStorage.setItem("urlReturn", history.location.pathname);
  }

  render() {
    const { drafts } = this.state;
    const { match } = this.props;

    return (
      <div>
        <Breadcrumb
          title="Campanha de Mensagens"
          description="Monte aqui sua campanha"
        />

        <section className="content-wrapper content-wrapper--large">
          <Tabs
            sections={[
              { title: 'Nova Campanha', path: `${match.url}/criar` },
              { title: 'Rascunhos', path: `${match.url}/rascunhos`, badge: drafts.length }
            ]}
          />

          <Route
            path={`${match.url}/criar`}
            render={() => <NewCampaign loadDrafts={this.loadDrafts} />}
          />
          <Route
            path={`${match.url}/rascunhos`}
            render={() => <Drafts drafts={drafts} loadDrafts={this.loadDrafts} />}
          />
        </section>
      </div>
    )
  }
}

export default Campaigns;



// WEBPACK FOOTER //
// ./src/screens/client/campaigns/Campaigns.js